import React from 'react';
import LazyPageLoader from '../../cmp/LazyPageLoader';

const Page = React.lazy(()=>import('./HelpPage'))

export default function LazyHelpPage(props){
    return <React.Suspense fallback={<LazyPageLoader />}>
        <Page />
    </React.Suspense>
}
